import React from 'react'
import PropTypes from 'prop-types'
import styles from './master-form.module.css'
import { CustomerType } from './master-form'

export default class StepAddress extends React.Component {
  render() {
    const question = this.props.customerType === CustomerType.Home ? 'What is your address?' : 'What is your business address?'
    return (
      <>
        <p className={styles.question}>{question}</p>
        <div className={styles.formText}>
          <label htmlFor="street1">Address</label>
          <input
            type="text"
            className={styles.formTextInput}
            id="street1"
            name="street1"
            value={this.props.street1}
            onChange={this.props.handleChange}
          />
        </div>
        <div className={styles.formText}>
          <label htmlFor="city">Town/City</label>
          <input
            type="text"
            className={styles.formTextInput}
            id="city"
            name="city"
            value={this.props.city}
            onChange={this.props.handleChange}
          />
        </div>
        <div className={styles.formText}>
          <label htmlFor="postcode">Postcode</label>
          <input
            type="text"
            className={styles.formTextInput}
            id="postcode"
            name="postcode"
            value={this.props.postcode}
            onChange={this.props.handleChange}
          />
        </div>
        <p className={styles.subQuestion}>This ensures your quotes are accurate.</p>
      </>
    )
  }
}

StepAddress.propTypes = {
  customerType: PropTypes.string.isRequired,
  street1: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  postcode: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
}